import React, { useEffect } from 'react'
import { Container } from '@mui/material'
import { IContactUsForm } from '../../interface'
import { useNavigate } from 'react-router-dom'
import ContactUsForm from '../../components/ContactUs/ContactUsForm'
import { sendEmailToTrainingGQL } from 'src/services/graphql/schemas/emails'
import { NotificationManager } from 'src/functions/notifications'
import { FormattedMessage } from 'react-intl'
import { getFormData, getRecaptchaToken } from 'src/utils'
import { useRecaptcha } from 'src/customHooks/useRecaptcha'

const ContactUsTraining = (props: { selectedProduct: string }) => {
  const navigate = useNavigate()
  const { userInfo, isAuthenticated, cookieCountryCode } = getFormData()
  const { recaptchaToken, handleTokenChange } = useRecaptcha()
  const { selectedProduct } = props

  /**
   * Calls sendEmailToTrainingGQL, if it returns status code 200, confirmation url is pushed into the history
   * @function onSubmit
   * @param {IContactUsForm} values - values of the form.
   * @returns  void
   */

  const onSubmit = async (values: IContactUsForm) => {
    const { name, email, phone, comments, country, state, organization } = values
    let userData

    if (userInfo) {
      userData = {
        FirstName: name,
        Email: email,
        PhoneNumber: phone,
        AccountNumber: userInfo.DefaultShipToAccount
      }
      if (country && state) {
        const success = await sendEmailToTrainingGQL(
          userData,
          selectedProduct,
          comments,
          country,
          state,
          organization,
          getRecaptchaToken(recaptchaToken)
        )
        if (success === 200) {
          NotificationManager.success(<FormattedMessage id='notification.messageSent' />)
          return navigate('/private-classes/confirmation', { replace: true })
        } else {
          NotificationManager.error(<FormattedMessage id='notification.systemError' />)
        }
      } else {
        NotificationManager.error(<FormattedMessage id='notification.onlyDomesticAuthorized' />)
      }
    }
  }

  useEffect(() => {
    if (!selectedProduct) navigate('/store', { replace: true })
  }, [])

  return (
    <Container data-gtm-click-section={selectedProduct} data-cy='contactus-container'>
      <ContactUsForm
        onSubmit={onSubmit}
        disabledField={true}
        isAuthenticated={isAuthenticated}
        cookieCountryCode={cookieCountryCode}
        userInfo={userInfo}
        recaptchaToken={recaptchaToken}
        handleTokenChange={handleTokenChange}
      />
    </Container>
  )
}

export default ContactUsTraining
